<template>
  <div class="home">
    <carousel :per-page="1" pagination-position="bottom-overlay" :autoplay="true" :loop="true">
      <slide v-for="(item, index) in carouselImgs" :key="index">
        <img :src="item" width="100%"/>
      </slide>
    </carousel>
    <div class="pros">
      <p>我们的优势</p>
      <div v-for="(item, index) in prosImgs" :key="index">
        <img style="margin: 10px 30px" v-for="(image, index) in item" :key="`${index}-image`" :src="image" width="30%"/>
      </div>
    </div>
    <div class="feature">
      <p>基于微信群的校园管理云平台</p>
      <div class="container">
        <img v-for="(item, index) in featureImgs" :key="index" :src="item"/>
      </div>
    </div>
    <div class="content">
      <img v-for="(item, index) in contentImgs" :key="index" :src="item" width="100%"/>
    </div>
    <div class="school-window">
      <carousel :per-page="4" :pagination-enabled="false" :navigation-enabled="true" :pagination-padding="20">
        <slide v-for="(item, index) in schoolImgs" :key="index">
          <div class="image-root">
            <img :src="item" width="100%">
          </div>
        </slide>
      </carousel>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
  name: 'home',
  components: {
    Carousel, Slide
  },
  data() {
    return {
      carouselImgs: [
        require('../../../assets/page1.jpg'),
        require('../../../assets/page2.jpg'),
        require('../../../assets/page3.jpg'),
        require('../../../assets/page4.jpg'),
      ],
      prosImgs: [
        [
          require('../../../assets/ruler.png'),
          require('../../../assets/simple.png')
        ],
        [
          require('../../../assets/power.png'),
          require('../../../assets/serve.png')
        ]
      ],
      featureImgs: [
        require('../../../assets/feature1.png'),
        require('../../../assets/feature2.png'),
        require('../../../assets/feature3.png'),
        require('../../../assets/feature4.png'),
        require('../../../assets/feature5.png'),
      ],
      contentImgs: [
        require('../../../assets/moral.png'),
        require('../../../assets/evaluation.png'),
        require('../../../assets/teach.png'),
        require('../../../assets/interactive.png')
      ],
      schoolImgs: [
        require('../../../assets/school/fjgzzx.jpeg'),
        require('../../../assets/school/fjfz18zx.png'),
        require('../../../assets/school/fjfzpdzx.png'),
        require('../../../assets/school/hhhtsyjyjt.png'),
      ]
    }
  },
}
</script>

<style lang="less" scoped>
.pros{
  padding: 0;
  background-color: #ecfbdc;
  font-size: 26px;
  margin-top: -20px;
  p {
    margin: 0;
    padding-top: 50px;
  }
  // margin-top: -20px;
}
.feature {
  p {
    text-align: center;
    font-size: 26px;
  }
  .container {
    margin: auto;
    text-align: center;
    img {
      width: 130px;
      margin: 0 10px;
    }
  }
}
.content {
  margin-top: 40px;
  img {
    margin-top: -20px; 
  }
}
.school-window {
  width: 60%;
  margin: 20px auto;
  .image-root {
    display: flex;
    align-items: center;
    height: 100%;
    margin: 0 10px;
  }
}
</style>

